export type UserSchoolRole = 'teacher' | 'student' | 'admin';

export type UserSchool = {
  id: string;
  userId: string;
  schoolId: string;
  role: UserSchoolRole;
};
